import moment from 'moment-timezone';
import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';

import { 
  searchPaginatedContactList, getContactReportCsv
} from '../app/store/actions/projectsDirectory';
import ModalComponent from '../components/modal';
import Table from '../components/table/table';

class ContactoOfProjectsForIntegratorsPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      limit: 20,
      page: 1,
      search: '',
      orderBy: 'DESC',
      field: 'createdAt',
      dataList: [],
      totalRecord: 0,
      showModal: false,
      showCancel: false,
      titleModal: '',
      titleModalBody: '',
    };

    this.tableHeader = [
      { key: 'type', value: I18n.t('requestType') },
      { key: 'referentName', value: I18n.t('nameReference'), notDisplay: true },
      { key: 'applicantsName', value: I18n.t('applicantsName') },
      { key: 'phone', value: I18n.t('phone') },
      { key: 'email', value: I18n.t('email2') },
      { key: 'business', value: I18n.t('company') },
      { key: 'region', value: I18n.t('region') },
      { key: 'district', value: I18n.t('province') },
      { key: 'message', value: I18n.t('message') },
      { key: 'createdAt', value: I18n.t('requestDate') },
    ];
  }

  componentDidMount() {
    this.getSearchPaginatedContactList();
  }

  getRegion = (regionValue) => {
    let regionLabel = '';
    if (regionValue === 1) regionLabel = 'Región de Arica y Parinacota';
    else if (regionValue === 2) regionLabel = 'Región de Tarapacá';
    else if (regionValue === 3) regionLabel = 'Región de Antofagasta';
    else if (regionValue === 4) regionLabel = 'Región de Atacama';
    else if (regionValue === 5) regionLabel = 'Región de Coquimbo';
    else if (regionValue === 6) regionLabel = 'Región de Valparaíso';
    else if (regionValue === 7) regionLabel = 'Región Metropolitana de Santiago';
    else if (regionValue === 8) regionLabel = 'Región del Libertador General Bernardo O’Higgins';
    else if (regionValue === 9) regionLabel = 'Región del Maule';
    else if (regionValue === 10) regionLabel = 'Región del Ñuble';
    else if (regionValue === 11) regionLabel = 'Región del Biobío';
    else if (regionValue === 12) regionLabel = 'Región de La Araucanía';
    else if (regionValue === 13) regionLabel = 'Región de Los Ríos';
    else if (regionValue === 14) regionLabel = 'Región de Los Lagos';
    else if (regionValue === 15) regionLabel = 'Región de Aysén del General Carlos Ibáñez del Campo';
    else if (regionValue === 16) regionLabel = 'Región de Magallanes y la Antártica Chilena';

    return regionLabel;
  }

  getType = (typeValue) => {
    let typeLabel = '';
    if (typeValue === 1) typeLabel = I18n.t('contact');
    else if (typeValue === 2) typeLabel = I18n.t('projectsDirectory');
    else if (typeValue === 3) typeLabel = I18n.t('technicalMaterial');
    else if (typeValue === 4) typeLabel = I18n.t('coursesAndTraining');

    return typeLabel;
  }

  getReferentName = (element) => {
    let referentName = '';
    if (element.type === 2 && element.projectsDirectory) referentName = element.projectsDirectory.projectName;
    else if (element.type === 4 && element.coursesAndTraining) referentName = element.coursesAndTraining.name;

    return referentName;
  }

  adjustData = async (count = 0, rows = []) => {
    const dataList = rows.map(element => ({
      key: element.id,
      type: this.getType(element.type),
      referentName: this.getReferentName(element),
      applicantsName: element.applicantsName,
      phone: element.phone,
      email: element.email,
      business: element.business,
      region: this.getRegion(element.region),
      district: element.district,
      message: element.message,
      createdAt: `${moment(element.createdAt).format('DD-MM-YYYY')}`,
    }));

    this.setState({
      totalRecord: count,
      dataList,
    });
  }

  getSearchPaginatedContactList = async () => {
    const {
      search, page, limit, orderBy = '', field = '',
    } = this.state;
    const skip = (page - 1) * limit;

    try {
      const { count = 0, rows = [] } = await this.props.searchPaginatedContactList(
        limit, skip, search, orderBy, field,
      );

      await this.adjustData(count, rows);
    } catch (err) {
      const error = err.response && err.response.data && err.response.data.error;
      if (error && error.message) {
        const messageError = (error.code && error.details)
          ? `${error.code} - ${error.details} | ${error.message}`
          : error.message;

        this.setState({
          showModal: true,
          showCancel: false,
          titleModal: I18n.t('Error'),
          titleModalBody: messageError,
        });
      } else {
        this.setState({
          showModal: true,
          showCancel: false,
          titleModal: I18n.t('Error'),
          titleModalBody: I18n.t('erroFetch'),
        });
      }
    }
  }

  getContactReport = async () => {
    try {
      await this.props.getContactReportCsv();
    } catch (err) {
      const error = err.response && err.response.data && err.response.data.error;
      if (error && error.message) {
        const messageError = (error.code && error.details)
          ? `${error.code} - ${error.details} | ${error.message}`
          : error.message;

        this.setState({
          showModal: true,
          titleModal: I18n.t('Error'),
          titleModalBody: messageError,
        });
      } else {
        this.setState({
          showModal: true,
          titleModal: I18n.t('Error'),
          titleModalBody: I18n.t('erroFetch'),
        });
      }
    }
  }

  sortTable = async (field, orderBy) => {
    await this.setState({ orderBy, field });
    await this.getSearchPaginatedContactList();
  }

  searchTable = async (search = '', page = 1) => {
    await this.setState({ search, page });
    await this.getSearchPaginatedContactList();
  }

  render() {
    const {
      limit, page, dataList, totalRecord, titleModal, titleModalBody, showModal, showCancel,
    } = this.state;
  
    const tableButtons = (
      <button
        onClick={this.getContactReport}
        type="button"
        className="btn btn-secondary margin-left-10"
      >
        {I18n.t('export')}
      </button>
    );
  
    return (
      <div className="main-div-tables">
        <ModalComponent
          title={titleModal}
          showCancel={showCancel}
          body={titleModalBody}
          visible={showModal}
          closeModal={() => this.setState({ showModal: false })}
          titleOkButtoon={I18n.t('ok')}
          size={{ width: '350px', height: '200px' }}
          showButtons
          confirmModal={() => this.setState({ showModal: false })}
        />

        <Table
          title={I18n.t('integratorContactList')}
          header={this.tableHeader}
          buttons={tableButtons}
          lines={dataList}
          page={page}
          perPage={limit}
          count={totalRecord || 0}
          searchItems={this.searchTable}
          showItemsCount
          sortTable={this.sortTable}
        />
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  searchPaginatedContactList: (limit, skip, search, orderBy, field) => dispatch(
    searchPaginatedContactList(limit, skip, search, orderBy, field),
  ),
  getContactReportCsv: () => dispatch(getContactReportCsv()),  
});

const mapStateToProps = (/* state */) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(ContactoOfProjectsForIntegratorsPage);
